function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
(function() {
    "use strict";
    var SolutionsMenuHandler = /*#__PURE__*/ function() {
        function SolutionsMenuHandler() {
            _class_call_check(this, SolutionsMenuHandler);
            this.initSettings();
            this.initElements();
            this.markActiveMenuItems();
            this.bindEvents();
        }
        _create_class(SolutionsMenuHandler, [
            {
                key: "initSettings",
                value: function initSettings() {
                    this.settings = {
                        selectors: {
                            body: "body",
                            toggle: "#solutions-navigation-toggle",
                            dropdown: "#solutions-navigation-dropdown",
                            menuItems: "#solutions-navigation-dropdown .menu-item"
                        },
                        hoverDelay: 100
                    };
                    this.closeTimeout = null;
                    this.menuLocked = false;
                }
            },
            {
                key: "initElements",
                value: function initElements() {
                    this.elements = {
                        $body: jQuery(this.settings.selectors.body),
                        $toggle: jQuery(this.settings.selectors.toggle),
                        $dropdown: jQuery(this.settings.selectors.dropdown),
                        $menuItems: jQuery(this.settings.selectors.menuItems)
                    };
                }
            },
            {
                // Flag any menu item whose link matches the current page
                key: "markActiveMenuItems",
                value: function markActiveMenuItems() {
                    var currentPath = window.location.pathname.replace(/\/$/, "");
                    this.elements.$menuItems.each(function(_, el) {
                        var $link = jQuery(el).find("a").first();
                        var linkPath = new URL($link[0].href).pathname.replace(/\/$/, "");
                        if (linkPath === currentPath) {
                            jQuery(".solutions-navigation-toggle").attr("data-persistent-active", "true");
                            jQuery(el).attr("data-persistent-active", "true");
                            $link.addClass("active");
                        }
                    });
                }
            },
            {
                key: "bindEvents",
                value: function bindEvents() {
                    var _this = this;
                    this.elements.$toggle.on("mouseenter", function() {
                        return _this.openMenu();
                    });
                    this.elements.$dropdown.on("mouseenter", function() {
                        return _this.clearCloseTimeout();
                    });
                    this.elements.$toggle.on("mouseleave", function() {
                        return _this.delayedClose();
                    });
                    this.elements.$dropdown.on("mouseleave", function() {
                        return _this.delayedClose();
                    });
                    this.elements.$dropdown.on("click", ".menu-item-has-children > a", this.toggleSubmenu);
                    jQuery(document).on("click", function(e) {
                        if (!_this.elements.$toggle.is(e.target) && !_this.elements.$toggle.has(e.target).length && !_this.elements.$dropdown.is(e.target) && !_this.elements.$dropdown.has(e.target).length) {
                            if (_this.menuLocked) {
                                _this.menuLocked = false;
                                _this.closeMenu();
                            }
                        }
                    });
                }
            },
            {
                key: "openMenu",
                value: function openMenu() {
                    this.clearCloseTimeout();
                    if (this.elements.$dropdown.attr("aria-hidden") === "false") return;
                    // window.scrollTo(0, 0);
                    this.elements.$toggle.addClass("active");
                    this.elements.$toggle.attr("aria-expanded", true);
                    this.elements.$dropdown.attr("aria-hidden", false);
                    this.elements.$body.addClass("open-solutions-nav nav-animating");
                    this.elements.$dropdown.css("transition-delay", "0s");
                    jQuery.each(this.elements.$menuItems, function(k, v) {
                        v.querySelector("a").tabIndex = 0;
                        v.classList.remove("transition-delay-none");
                    });
                }
            },
            {
                key: "closeMenu",
                value: function closeMenu() {
                    var _this = this;
                    this.elements.$toggle.removeClass("active");
                    this.elements.$toggle.attr("aria-expanded", false);
                    this.elements.$dropdown.attr("aria-hidden", true);
                    this.elements.$dropdown.css("transition-delay", "0.3s");
                    setTimeout(function() {
                        _this.elements.$body.removeClass("open-solutions-nav");
                    }, 0);
                    setTimeout(function() {
                        _this.elements.$body.removeClass("nav-animating");
                    }, 900);
                    jQuery.each(this.elements.$menuItems, function(k, v) {
                        var $el = jQuery(v);
                        var $link = $el.find("a").first();
                        v.querySelector("a").tabIndex = -1;
                        v.classList.add("transition-delay-none");
                        // Don't remove 'active' if it matches current page
                        if (!$el.attr("data-persistent-active")) {
                            $link.removeClass("active");
                        }
                    });
                }
            },
            {
                key: "delayedClose",
                value: function delayedClose() {
                    var _this = this;
                    this.clearCloseTimeout();
                    if (this.menuLocked) return;
                    this.closeTimeout = setTimeout(function() {
                        _this.closeMenu();
                    }, this.settings.hoverDelay);
                }
            },
            {
                key: "clearCloseTimeout",
                value: function clearCloseTimeout() {
                    if (this.closeTimeout) {
                        clearTimeout(this.closeTimeout);
                        this.closeTimeout = null;
                    }
                }
            },
            {
                key: "toggleSubmenu",
                value: function toggleSubmenu(e) {
                    var $parent = jQuery(e.currentTarget).parent("li");
                    $parent.toggleClass("elementor-active");
                }
            }
        ]);
        return SolutionsMenuHandler;
    }();
    jQuery(function() {
        new SolutionsMenuHandler();
    });
})();
